exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-xs[data-v-58950a06]{padding:.125rem .25rem;font-size:.75rem;line-height:1;border-radius:.15rem}.table[data-v-58950a06]{width:100%;table-layout:fixed}.form-control[data-v-58950a06]{height:calc(1.8125rem + 2px);padding:.25rem .5rem;font-size:12px;line-height:1.5;border-radius:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58950a06","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/CDCShareHolderImport.vue
// module id = 220
// module chunks = 0